$(document).ready(function() {
	$.tablesorter.addParser({
		// set a unique id
		id : 'trCurrency',
		is : function(s) {
			// return false so this parser is not auto detected
			return false;
		},
		format : function(s) {
			// format your type for normalization
			var n = s;
			var pattern = /[^0-9,\.]/g;
			n = n.replace(pattern,''); //remove all characters except numbers,"." and ","
			
			n = n.replace(/\./g, ''); //remove all thousand reperators (".")	
			n = n.replace(',', '.');  //change decimal seperator "," to "."
					
			return n;
		},
		// set type, either numeric or text
		type : 'numeric'
	});
});